import type { PopoverBodyProps as ChakraPopoverBodyProps } from '@chakra-ui/react';
import { PopoverBody as ChakraPopoverBody } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type PopoverBodyProps = OmitChakraProps<ChakraPopoverBodyProps>;

export const PopoverBody = withChakraAs<PopoverBodyProps, 'div'>((props) => {
  return <ChakraPopoverBody {...props} />;
});
